import React from 'react';
import { Form, Input } from 'antd';
import AudioInput from '../../components/media/AudioInput';
import PictureInput from '../../components/media/PictureInput';

const FootBathItem: React.FC<any> = ({ form, prefix, fullPrefix }: any) => {
    return (
        <div>
            <Form.Item
                name={[...prefix, 'foot_duration']}
                label={`时间`}
                rules={[{ required: true, message: '不能为空' }]}
            >
                <Input.TextArea />
            </Form.Item>
            <Form.Item
                name={[...prefix, 'water_temperature']}
                label={`水温`}
                rules={[{ required: true, message: '不能为空' }]}
            >
                <Input.TextArea />
            </Form.Item>
            <PictureInput form={form} prefix={prefix} fullPrefix={fullPrefix} />
            <AudioInput form={form} prefix={prefix} fullPrefix={fullPrefix} />
        </div>
    );
};
export default FootBathItem;